import axios from "axios";

const getAdditionalInfoSequence = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/serialnumber/api/v1/additional-info/sequence?length=${parameters.length}&start=${parameters.start}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAdditionalInfoSequence;
